module.exports = __webpack_public_path__ + "assets/img/bgc.1c184ac0.png";